<mat-form-field color="primary" class="single-date-range-picker w-[230px]" [formGroup]="range">
  <mat-label></mat-label>
  <div class="flex items-center w-fit justify-center !bg-inherit">
      <mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="this.isDatePickerDisabled()" [id]="'singleDateRangePicker'" />
      @if (!this.value() && this.hideEmptyValues) {
          <span class="!text-[#71787E]" i18n>No range set</span>
      }
      <div [hidden]="!this.value() && this.hideEmptyValues">
          <mat-date-range-input [rangePicker]="picker" class="!text-[#71787E] !bg-inherit">
              <input matStartDate readonly formControlName="startDate" placeholder="Start date" >
              <input matEndDate readonly formControlName="endDate" placeholder="End date"   >
          </mat-date-range-input>
      </div>
  </div>
  <mat-date-range-picker #picker panelClass="!w-[394px] !h-[280px] !text-base date-range-picker" [disabled]="this.isDatePickerDisabled()" >
      <mat-date-range-picker-actions class="flex !flex-col">
          <div class="h-[130px] flex items-center pt-[25px]">
              <mat-date-range-picker #picker [disabled]="this.isDatePickerDisabled()"/>
          </div>
  
          <div class="solid"></div>
          <div class="flex self-end gap-[7px] h-[60px] pr-[8px] action-buttons">
              <button mat-button matDateRangePickerCancel
                  class="text-sm font-medium"  i18n>Cancel</button>
              <button mat-button matDateRangePickerApply (click)="onSubmit($event)"
                  class="text-sm font-medium" i18n>Apply</button>
          </div>
      </mat-date-range-picker-actions>
  </mat-date-range-picker>
</mat-form-field>